<template>
    <div :class="[{ 'lb-creation-card': showControls }, cardSizeClass]">
        <div
            ref="card"
            :class="cardSizeClass"
            class="lb-card"
            @mouseover="showToolbar = true"
            @mouseleave="showToolbar = false"
        >
            <div 
                
            >
                <div
                    v-if="hasAccess && showToolbar && !editing && canEdit"
                    class="buttons has-addons toolbar"
                >
                    <a
                        class="button is-dark"
                        @click.stop="showOrEdit"
                    >
                        <span class="icon is-small">
                            <i class="fas fa-edit" />
                        </span>
                    </a>
                </div>
                <div class="lb-card-content">
                    <div 
                        v-if="model.title || content.title"
                        :class="{ field: isEdition }"
                        class="content-header"
                    >
                        <textarea
                            v-if="showControls"
                            v-model="content.title"
                            :class="{ 'is-static': !showControls }"
                            :readonly="!showControls"
                            :placeholder="
                                $t(
                                    model.related
                                        ? 'creation.question_hint'
                                        : titlePlaceholder
                                )
                            "
                            class="
                                input
                                card-header-title
                                title
                                is-size-5
                                px-2
                                py-2
                            "
                            type="text"
                        />
                        <div v-else class="level is-mobile">
                            <div class="level-left is-shrinkable">
                                <div class="level-item is-shrinkable">
                                    <div v-if="content.answers">
                                        <p
                                            class="
                                                card-header-title
                                                title
                                                is-paddingless
                                                is-size-5
                                                is-block
                                            "
                                        >
                                            {{ getName(content) }}
                                        </p>
                                        <p
                                            class="
                                                is-paddingless is-size-7
                                                has-text-grey
                                                is-block is-fullwidth
                                            "
                                        >
                                            {{
                                                $t(
                                                    'creation.answer_type.' +
                                                        content.answerType
                                                )
                                            }}
                                        </p>
                                    </div>
                                    <p
                                        v-else
                                        class="
                                            card-header-title
                                            title
                                            is-paddingless is-size-5 is-block
                                        "
                                        :class="{'is-clickable':canOpenObject}"
                                        @click="openObject(content)"
                                    >
                                        {{ getName(content) }}
                                    </p>
                                </div>
                            </div>
                            <div v-if="showOwner" class="level-right">
                                <div class="level-item">
                                    <p
                                        :data-tooltip="
                                            contentOwner
                                        "
                                        class="
                                            image
                                            is-24x24
                                            has-tooltip-bottom
                                        "
                                    >
                                        <img
                                            :src="content.owner.avatar"
                                            referrerpolicy="no-referrer"
                                            loading="lazy"
                                            class="is-rounded lb-avatar"
                                        />
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="level-right px-0 py-0">
                        <div class="navbar-item has-dropdown is-hoverable px-0 py-0" v-if="isMultilang">
                            <a class="navbar-link is-arrowless px-0 py-0" style="text-transform: capitalize;">
                                <!--<span class="icon"><i class="mdi mdi-28px mdi-web"></i></span>-->
                                {{ langLabel(activeLang) }}
                            </a>

                            <div class="navbar-dropdown">
                                <a
                                    v-for="lang in languages"
                                    :key="lang"
                                    @click="activeLang = lang"
                                    class="navbar-item"
                                    style="text-transform: capitalize;"
                                >
                                    {{ langLabel(lang) }}
                                </a>
                            
                            </div>
                        </div>
                                               
                    </div>
                    <hr
                        v-if="showControls && model.description"
                        class="is-paddingless"
                    />
                    <!--<input-rich-text
                        v-if="
                            (showControls && model.description) ||
                            content.description
                        "
                        v-model="content.description"
                        :editable="showControls"
                        :placeholder="descriptionPlaceholder"
                    />-->
                    <div class="cutted-text description pb-0 mb-2" ref="description" v-if="getDescription" ><div v-html="getDescription"/></div>
                    <div class="showMore pt-0 has-text-weight-bold is-clickable has-text-primary" v-if="showMore" @click="expandText">{{$t('show_more')}}</div>
                    <div class="showMore pt-0 has-text-weight-bold is-clickable has-text-primary" v-if="showLess" @click="compressText">{{$t('show_less')}}</div>
                    <object-card-tags
                        v-if="content.tags"
                        :tags="content.tags"
                    />
                    <object-card-media
                        :show-controls="showControls"
                        :location.sync="content.location"
                        :images.sync="content.images"
                        :files="getFiles(activeLang)"
                        :embed.sync="content.embed"
                        :audio="getAudio(activeLang)"
                        :video="getVideo(activeLang)"
                        :url="getUrl(activeLang)"
                        @zoomImage="zoomImage"
                    />
                    <div v-if="showAnswers" >
                        <div
                            v-for="(answer, index) in objectAnswers"
                            :key="index"
                        >
                            <hr />
                            <div v-if="answer.value">
                                <p class="subtitle is-size-6 lb-answer-disabled" :class="answer.correct && (content.answerType=='SINGLE'||content.answerType=='MULTIPLE')?'active':''">
                                    {{ answer.value }}
                                </p>
                            </div>
                            <div v-else>
                                <p class="subtitle is-size-6 lb-answer-disabled">
                                    {{ $t('min_val') }} {{ answer.valueMin }}
                                </p>
                                <p class="subtitle is-size-6 lb-answer-disabled">
                                    {{ $t('max_val') }} {{ answer.valueMax }}
                                </p>
                            </div>
                            
                        </div>
                    </div>
                    <!--<object-card-related
                        v-if="model.related"
                        v-show="isEdition || isCreation"
                        :show-creation="showControls"
                        :answers.sync="content.answers"
                        :answer-type.sync="content.answerType"
                    />-->
                    <!--<object-card-toolbar
                        v-if="showControls"
                        :options="model.media"
                        :expanded="cardSize == 'LARGE'"
                        @click="openModal"
                    />-->
                    
                    <!-- like & share toolbar -->
                    <!--<div
                        v-if="!showControls"
                        class="level is-mobile mb-0 pt-0"
                        @click.stop
                    >
                        <div
                            :class="{ 'has-cursor-pointer': isLoggedIn }"
                            class="level-left"
                        >
                            <div
                                v-if="$store.getters.canLikeObjects"
                                :class="{ 'has-text-primary': content.liked }"
                                class="level-item"
                                @click="toggleLike"
                            >
                                <p class="has-text-weight-bold">
                                    {{ content.likes || 0 }}
                                </p>
                                <span class="icon is-medium">
                                    <i
                                        class="mdi mdi-18px mdi-thumb-up"
                                        aria-hidden="true"
                                    ></i>
                                </span>
                            </div>
                        </div>
                        <div class="level-right">
                            <div class="level-item">
                                <div
                                    class="
                                        dropdown
                                        is-right is-hoverable is-pulled-right
                                    "
                                >
                                    <span
                                        class="
                                            icon
                                            is-small
                                            dropdown-trigger
                                            has-text-grey
                                        "
                                    >
                                        <i
                                            class="
                                                mdi mdi-24px mdi-dots-vertical
                                            "
                                            aria-hidden="true"
                                        />
                                    </span>
                                    <div class="dropdown-menu" role="menu">
                                        <div class="dropdown-content">
                                            <div class="dropdown-item">
                                                <a
                                                    v-t="'Object.share'"
                                                    @click="
                                                        showShareModal = true
                                                    "
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>-->
                    <!--<div class="object-card-comments-zone" v-if="!showControls && canAddComment">
                        <object-card-comments
                            
                            :comments="content.comments"
                            :object="content"
                            @loadOldComments="$emit('click')"
                            
                        />
                    </div>-->
                </div>
            </div>
            <project-modal-share
                v-if="showShareModal"
                :content="content"
                @close="showShareModal = false"
            ></project-modal-share>
        </div>
    </div>
</template>

<script>
import ObjectCardToolbar from '@/components/ObjectCardToolbar';
import ObjectCardRelatedToolbar from '@/components/ObjectCardRelatedToolbar';
import ObjectCardMedia from '@/components/ObjectCardMedia';
import ObjectCardRelated from '@/components/ObjectCardRelated';
import ObjectCardTags from '@/components/ObjectCardTags';
import ObjectCardComments from '@/components/ObjectCardComments';
import AppCollapsableText from '@/components/AppCollapsableText';
import vClickOutside from 'v-click-outside';
import InputRichText from '@/components/InputRichText';
import _ from 'underscore';
import { likeObject } from '@/services/API';
import ProjectModalShare from '@/components/ProjectModalShare';
export default {
    name: 'ObjectCard',
    components: {
        ObjectCardToolbar,
        ObjectCardMedia,
        ObjectCardRelated,
        ObjectCardRelatedToolbar,
        ObjectCardTags,
        ObjectCardComments,
        InputRichText,
        AppCollapsableText,
        ProjectModalShare,
    },
    directives: {
        clickOutside: vClickOutside.directive,
    },
    props: {
        content: {
            type: Object,
            default() {
                return {};
            },
        },
        model: {
            type: Object,
            default() {
                return {};
            },
        },
        isCreation: { type: Boolean, default: false },
        isEdition: { type: Boolean, default: false },
        modalOpened: { type: Boolean, default: false },
        showAnswers: {
            type: Boolean,
            default: false,
        },
        hasLocation: {
            type: Boolean,
            default: false,
        },
        editing: {
            type: Boolean,
            default: false,
        },
        canEdit: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showToolbar: false,
            showEdition: false,
            showShareModal: false,
            resizeObserver: new ResizeObserver((entries) => {
                for (let entry of entries) {
                    this.$emit('resize');
                }
            }),
            showMore: false,
            showLess: false,
            activeLang: this.$store.getters.project.langs && this.$store.getters.project.defaultLang ? this.$store.getters.project.defaultLang : this.$store.getters.project.langs && !this.$store.getters.project.defaultLang ? this.$store.getters.project.langs[0] : '',
        };
    },
    computed: {
        contentOwner() {
            return this.content.owner.alias || (this.content.owner.name + " " + this.content.owner.surname);
                                            
        },
        showOwner() {
            // console.log(this.content.accessLevel)
            if (this.content.owner && this.content.accessLevel=='administrator') {
                return true;
            }
            return false;
        },
        contentURL() {
            return window.location.href;
        },
        relatedContent: {
            get() {
                const relatedObjects = _.pluck(this.model.related, 'name');
                return _.pick(this.content, relatedObjects);
            },
            set() {
                console.log('here set related content');
            },
        },
        mediaContent() {
            const mediaObjects = _.pluck(this.model.media, 'name');
            return _.pick(this.content, mediaObjects);
        },
        hasAccess() {
            if (this.isCreation) {
                return true;
            }
            return this.content.accessLevel == 'administrator';
        },
        showControls() {
            return this.isEdition || this.isCreation;
        },
        cardSize() {
            return this.$store.getters['Project/cardSize'];
        },
        cardSizeClass() {
            return `is-${this.cardSize.toLowerCase()}`;
        },
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        canAddComment() {

            if (this.isLoggedIn && this.$store.getters.canCommentInObjects && this.$route.name!="project-view") {
                return true;
            }
            return false;
        },
        titlePlaceholder() {
            // console.log(this.$store.getters.projectContent)
            if (
                this.$store.getters.project.type == 'treasurehunt' &&
                this.$store.getters.projectContent.length == 1
            ) {
                return 'creation.treasurehunt_title_hint';
            }
            return 'creation.title_hint';
        },
        descriptionPlaceholder() {
            // console.log(this.$store.getters.projectContent)
            if (
                this.$store.getters.project.type == 'treasurehunt' &&
                this.$store.getters.projectContent.length == 1
            ) {
                return this.$t('creation.treasurehunt_description_hint');
            }
            return '';
        },
        canOpenObject(){
            return this.$store.getters.project.format == "PROJECT_TYPE_WALL";
        },
        languages() {
            return this.$store.getters.project.langs;
        },
        isMultilang() {
            return this.$store.getters.project.langs && this.$store.getters.project.langs.length > 0;  
        },
        defaultLang() {
            return this.$store.getters.project.defaultLang;
        },
        hasAudio() {
            if (this.isMultilang && (this.content.audioPerLang && !_.isEmpty(this.content.audioPerLang))) {
                return true;
            }
            return false;
        },
        hasVideo() {
            if (this.isMultilang && (this.content.videoPerLang && !_.isEmpty(this.content.videoPerLang))) {
                
                return true;
            }
            return false;
        },
        hasUrl() {
            if (this.isMultilang && (this.content.urlPerLang && !_.isEmpty(this.content.urlPerLang))) {
                return true;
            }
            return false;
        },
        hasFiles() {
            if (this.isMultilang && this.content.filesPerLang && !_.isEmpty(this.content.filesPerLang)) {
                return true;
            }
            return false;
        },
        getDescription() {
            if (this.isMultilang) {
                let locale = this.$i18n.locale;
                if (locale == 'ca-ES') {
                    locale = "ca";
                }
                const defaultLang = this.$store.getters.project.defaultLang;
                // console.log("desc locale", locale)
                if (this.content.descriptionPerLang && this.content.descriptionPerLang[this.activeLang]) {
                    return this.content.descriptionPerLang[this.activeLang];
                }  else if (defaultLang && this.content.descriptionPerLang && this.content.descriptionPerLang[defaultLang]) {
                    // console.log("desc returning default")
                    return this.content.descriptionPerLang[defaultLang]
                } else if (this.content.descriptionPerLang && this.content.descriptionPerLang[locale]) {
                    // console.log("desc returning locale")
                    return this.content.descriptionPerLang[locale]
                }
                // console.log("no desc")
            } else {
                return this.content.description;
            }
        },
        objectAnswers() {
            if (this.isMultilang) {
                if (this.content.answersPerLang && !_.isEmpty(this.content.answersPerLang)) {
                    if (this.content.answersPerLang[this.activeLang]) {
                        return this.content.answersPerLang[this.activeLang];
                    } else if (this.content.answersPerLang[this.defaultLang]) {
                        return this.content.answersPerLang[this.defaultLang]
                    } else {
                        // console.log("return answers 1")
                        return this.content.answers
                    }
                } else {
                    // console.log("return answers 2")
                    return this.content.answers
                }
            }
            // console.log("return answers 0")
            return this.content.answers
        }
    },
    mounted() {
        this.resizeObserver.observe(this.$refs.card);
        if (this.hasLocation && this.isCreation && !this.content.location) {
            this.$emit('addElement', 'location');
        }
        if(this.$refs.description){
            if(this.$refs.description.scrollHeight>this.$refs.description.offsetHeight){
                this.showMore=true;
                this.$refs.description.classList.remove("mb-2");
            }
        }
    },
    destroyed() {
        this.resizeObserver.disconnect();
    },
    methods: {
        expandText(){
            this.$refs.description.classList.remove("cutted-text");
            this.showMore = false;
            this.showLess = true;
        },
        compressText(){
            this.$refs.description.classList.add("cutted-text");
            this.showMore = true;
            this.showLess = false;
        },
        enableEdition() {
            this.$emit('edit');
            this.showEdition = true;
        },
        onClickOutside(e) {
            if (!this.modalOpened) {
                if (_.isEmpty(this.content)) {
                    return this.$emit('cancel');
                }
                if (this.showControls) {
                    e.type != 'touchstart' && this.$emit('clickOutside');
                }
            }
        },
        openModal(e) {
            this.$emit('addElement', e.type);
        },
        openModalEdit(e) {
            this.showControls && this.$emit('addElement', e);
        },
        async toggleLike() {
            if (this.isLoggedIn) {
                let likeResult = await likeObject(this.content._id);
                this.content.liked = likeResult.data.liked;
                this.content.likes = likeResult.data.likes;
            }
        },
        validateAndSave() {
            //TODO: validate also type
            const requiredMedia = _.chain(this.model.media)
                .filter((media) => media.required)
                .pluck('name')
                .concat()
                .value();
            const requiredProps = _.chain(this.model)
                .pick((value, key) => {
                    return value.required;
                })
                .keys()
                .value();
            const requiredFields = requiredProps.concat(requiredMedia);
            const isValid = _.chain(requiredFields)
                .every((prop) => _.has(this.content, prop))
                .value();
            if (isValid) {
                this.$emit('save');
            } else {
                alert(this.$t('Error.MISSING_REQUIRED_FIELDS'));
            }
        },
        showOrEdit(){
            if(this.editing){
                return;
            }
            if(this.hasAccess){
                // console.log("editing object",this.content.title)
                this.$emit('edit',this.content);
            }
        },
        zoomImage(e){
            this.$emit('zoomImage',e);
        },
        openObject(object) {
            if(this.canOpenObject && !this.editing){
                this.$emit('show', object);
            }
            
            // console.log("opening object");
            
            /*this.activeObject = _.findWhere(this.filteredItems, {
                _id: object._id,
            });
            // this.activeMarker = object;
            this.showObjectModal = true;*/
        },
        langLabel(lang) {
            return this.$t("LANG_" + lang);
        },
        getName(item) {
            if (this.isMultilang) {
                let locale = this.$i18n.locale;
                if (locale == 'ca-ES') {
                    locale = "ca";
                }
                const defaultLang = this.$store.getters.project.defaultLang;
                // console.log("locale", locale)
                if (item.titlePerLang && item.titlePerLang[this.activeLang]) {
                    return item.titlePerLang[this.activeLang];
                }  else if (defaultLang && item.titlePerLang && item.titlePerLang[defaultLang]) {
                    // console.log("returning default")
                    return item.titlePerLang[defaultLang]
                } else if (item.titlePerLang && item.titlePerLang[locale]) {
                    // console.log("returning locale")
                    return item.titlePerLang[locale]
                }else {
                    // console.log("returning standar")
                    return item.title;
                }
                
            } else {
                return item.title;
            }
            
        },
        getAudio(lang) {
            if (this.content.audioPerLang && this.content.audioPerLang[lang]) {
                // console.log("audio correct lang")
                return this.content.audioPerLang[lang];
            } else if (this.content.audioPerLang && this.content.audioPerLang[this.defaultLang]) {
                // console.log("audio defaultLang")
                return this.content.audioPerLang[this.defaultLang]
            }
        },
        getVideo(lang) {
            if (this.content.videoPerLang && this.content.videoPerLang[lang]) {
                // console.log("video correct lang")
                return this.content.videoPerLang[lang];
            } else if (this.content.videoPerLang && this.content.videoPerLang[this.defaultLang]) {
                // console.log("video defaultLang")
                return this.content.videoPerLang[this.defaultLang]
            }
        },
        getUrl(lang) {
            if (this.content.urlPerLang && this.content.urlPerLang[lang]) {
                // console.log("video correct lang")
                // console.log(this.content.urlPerLang[lang])
                return this.content.urlPerLang[lang];
            } else if (this.content.urlPerLang && this.content.urlPerLang[this.defaultLang]) {
                // console.log("video defaultLang")
                // console.log(this.content.urlPerLang[this.defaultLang])
                return this.content.urlPerLang[this.defaultLang]
            }
        },
        getFiles(lang) {
            if (this.content.filesPerLang && this.content.filesPerLang[lang]) {
                // console.log("video correct lang")
                return this.content.filesPerLang[lang];
            } else if (this.content.filesPerLang && this.content.filesPerLang[this.defaultLang]) {
                // console.log("video defaultLang")
                return this.content.filesPerLang[this.defaultLang]
            }
        },
    },
};
</script>

<style scoped>
@import '../assets/css/object-card.css';

.lb-answer-disabled.active{
    background-color:darkgreen;
    color:#fff;
}

</style>
